import en from './en-US'
import zh from './zh-CN'
import zh_HK from './zh-HK'
import pt from './pt-PT'

const languages = {
  'en-US': en,
  'zh-CN': zh,
  'zh-HK': zh_HK,
  'pt-PT': pt
}

let currentLanguage = 'zh-CN'

export function setLanguage(lang) {
  if (languages[lang]) {
    currentLanguage = lang
  } else {
    console.warn(`Language ${lang} is not supported.`)
  }
}

export function $terms(key, params = []) {
  let translation = languages[currentLanguage][key] || key

  // Replace placeholders in the translation with actual values from params array
  params.forEach((param, index) => {
    const regex = new RegExp('\\{' + index + '\\}', 'g')
    translation = translation.replace(regex, param)
  })

  return translation
}
